console.log("@esm-bundle/autopublish-template is a repo that tests automatic publishing of repos")
require('./other.js')